import React, { useState, useEffect, Fragment } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container, ListGroup, ListGroupItem, ListGroupItemHeading } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';
// @ts-ignore
import CreatableSelect from 'react-select/creatable';
// @ts-ignore
import countryList from 'react-select-country-list'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
// @ts-ignore
import ReactFlagsSelect from 'react-flags-select';
//import css module
import 'react-flags-select/css/react-flags-select.css';

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew, positionList}: any) {
  
  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [userStatus, setUserStatus] = useState("Approved");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();
  
  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }
  
  // console.log(errors);
  // {errors}

  const userStatusOptions = [
    { value: 'Approved', label: 'Approved' },
    { value: 'Pending Approval', label: 'Pending Approval' },
    { value: 'De-Activated', label: 'De-Activated' }
  ];

  const userRolesOptions = [
    { value: 'NormalUser', label: 'NormalUser' },
    { value: 'Admin', label: 'Admin' }
  ];

  const positionOptions : any = [];
  var positionArray = positionList.split(',');
  for(var i = 0; i < positionArray.length; i++)
  {
      positionOptions.push({value: positionArray[i], label:positionArray[i]});
  }

  const salaryOptions = [
    { value: '1,500-3,000', label: '1,500-3,000' },
    { value: '3,001-5,000', label: '3,001-5,000' },
    { value: '5,001-8,000', label: '5,001-8,000' },
    { value: '8,001-12,000', label: '8,001-12,000' },
    { value: '12,001-20,000', label: '12,001-20,000' },
    { value: '25,001 and above', label: '25,001 and above' },
  ];

  const _countryOptions = countryList().getData();

  const handleMultiSelectedOption = (optionList: any, name: any) => {
    let arr: any = [];
    if (name){
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                return e.value; 
            }).indexOf(element);
    
            if (index !== -1) {
                arr.push(optionList[index]);
            }
            else {
                optionList.push({value: element, label: element});
                let index1 = optionList.map(function(e: any) { 
                    return e.value; 
                }).indexOf(element);
                arr.push(optionList[index1]);
            }
        });
    }
    return arr;
  }

  const handleSelectedOption = (optionList: any, name: string) => {
    let index = optionList.map(function(e: any) { 
        return e.value; 
    }).indexOf(name);

    if (index !== -1) {
        return optionList[index];
    }
  }

  return (
      <Fragment>
        <Form id='DetailsFrom' className="mt-3 mb-3" onSubmit={handleSubmit(onSubmit)}>
            
       {/* <input type="text" placeholder="First name" name="First name" ref={register({ required:true, minLength:10 })} />  */}
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Personal Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="fullName" sm={3}>Full Name as I.D.</Label >
                            <Col lg={6} sm={10}>
                                <Input type="text" name="fullName" defaultValue={props.data?.fullName} readOnly
                                    innerRef={register({ minLength:10 })} />
                                {errors.fullName && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="icNo" sm={3}>I.D. Number</Label >
                            <Col lg={3} sm={10}>
                                <Input type="text" name="icNo" readOnly
                                    defaultValue={props.data?.icNo}
                                    innerRef={register({  })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="permanentAdd" sm={3}>Home Address</Label >
                            <Col lg={6} sm={10}>
                                <Input type="textarea" name="permanentAdd" id="permanentAdd" readOnly
                                    defaultValue={props.data?.permanentAdd} rows={3} style={{width: "100%"}}
                                    innerRef={register({  })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactNo" sm={3}>Contact Number</Label >
                            <Col lg={3} sm={10}>
                                {/* <Input type="text" name="contactNo" readOnly
                                    defaultValue={props.data?.contactNo}
                                    innerRef={register({  })}
                                /> */}
                                <PhoneInput 
                                    disabled={true}
                                    country={'my'} 
                                    placeholder="+60 12-123 4567"
                                    enableSearch = {true}
                                    onlyCountries={['my','sg','kh']}
                                    masks={{my: '..-..........', sg: '..-..........', kh: '..-..........'}}
                                    value={props.data?.contactNo}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="emailAdd" sm={3}>Email Address</Label >
                            <Col lg={3} sm={10}>
                                <Input type="text" name="emailAdd"
                                    defaultValue={props.data?.emailAdd} readOnly
                                    innerRef={register({  })} />

                                {errors.emailAdd && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="country" sm={3}>Country</Label >
                            <Col lg={3} sm={10}>
                                {/* <Controller
                                    as={Select}
                                    name="country"
                                    options={_countryOptions}
                                    control={control}
                                    isDisabled={true}
                                    defaultValue={handleSelectedOption(_countryOptions, props.data?.country)}
                                /> */}
                                <ReactFlagsSelect 
                                    name="Country" 
                                    searchPlaceholder="Search for a country"
                                    defaultCountry={props.data?.country} 
                                    searchable={true}
                                    disabled={true}
                                    />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="userStatus" sm={3}>Status</Label >
                            <Col lg={3} sm={10}>
                                <Controller 
                                    as={<Select options={userStatusOptions} />}
                                    name="userStatus"                 
                                    control={control}
                                    rules={{ required: true }}
                                    onChange={([selected]) => {
                                        // Place your logic here
                                        //console.log(selected);
                                        return selected;
                                    }}
                                    defaultValue={{value : props.data?.userStatus, label:props.data?.userStatus}}
                                />
                                {errors.userStatus && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="userRoles" sm={3}>Roles</Label >
                            <Col lg={5} sm={10}>
                                <Controller
                                    as={Select}
                                    name="userRoles"
                                    options={userRolesOptions} 
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(userRolesOptions, props.data?.userRoles)}
                                />
                                {errors.userRoles && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br/>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Company Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="compName" sm={3}>Company Name</Label >
                            <Col lg={6} sm={9}>
                                <Input type="text" name="compName" id="compName" readOnly
                                    defaultValue={props.data?.compName}
                                    innerRef={register({  })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="compReg" sm={3}>Company Registration No.</Label >
                            <Col lg={6} sm={9}>
                                <Input type="text" name="compReg" id="compReg" readOnly
                                    defaultValue={props.data?.compReg}
                                    innerRef={register({  })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="compPosition" sm={3}>Your Position</Label >
                            <Col lg={5} sm={9}>
                                <Controller
                                    as={CreatableSelect}
                                    name="compPosition"
                                    options={positionOptions}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(positionOptions, props.data?.compPosition)}
                                    // isClearable={true}
                                    isDisabled={true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactNo" sm={3}>Company Contact Number</Label >
                            <Col lg={3} sm={10}>
                                <PhoneInput 
                                    disabled={true}
                                    country={'my'} 
                                    placeholder="+60 12-123 4567"
                                    enableSearch = {true}
                                    onlyCountries={['my','sg','kh']}
                                    masks={{my: '..-..........', sg: '..-..........', kh: '..-..........'}}
                                    value={props.data?.compContactNo}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="compAdd" sm={3}>Company Address</Label >
                            <Col lg={6} sm={9}>
                                <Input type="textarea" name="compAdd" id="compAdd" readOnly
                                    defaultValue={props.data?.compAdd} rows={5} style={{width: "100%"}}
                                    innerRef={register({  })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="compSalaryRange" sm={3}>Salary Range (RM)</Label >
                            <Col lg={5} sm={9}>
                                <Controller
                                    as={Select}
                                    name="compSalaryRange"
                                    options={salaryOptions}
                                    control={control}                        
                                    // isClearable={true}
                                    // isSearchable={true}
                                    isDisabled={true}
                                    defaultValue={handleSelectedOption(salaryOptions, props.data?.compSalaryRange)}
                                />
                            </Col>
                        </FormGroup>   
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br/>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Professional Category</ListGroupItemHeading>
                    <ListGroupItem>
                        <Col sm={12}>
                            {
                                props.data?.professionList?.map((e: any) => 
                                    <div className="row mb-3" style={{backgroundColor: "lightgrey"}}>
                                        <Label lg={12} sm={12}><b>{(e.profession === "TaxAgent") ? "Tax Agent" : (e.profession === "CompanySecretary") ? "Company Secretary": e.profession}</b></Label>
                                        {
                                            e.regulators?.map((elem: any) => {
                                                if(e.profession === "Contractor") {
                                                    return (                                               
                                                        <Row style={{margin: "0px", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Regulator</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.name}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Grade</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.grade}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Registration No</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.membershipNo}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                                else if(e.profession === "Others") {
                                                    return (                                               
                                                        <Row style={{margin: "0px", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Regulator</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.regulator}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Registration Number</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.registrationNo}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Association/Institution</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.association}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Membership Number</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.membershipNo}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                                else if (e.profession === "Engineering") {
                                                    return (
                                                        <Row style={{margin: "0px", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Regulator</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.name}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Registration No</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.membershipNo}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <Row style={{margin: "0px", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Regulator</Label >
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.name}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                            })
                                        }
                                        {
                                            e.associations?.map((elem: any, index: number) => {
                                                if(index === e.associations.length - 1 ) {
                                                    return (
                                                        <Row style={{margin: "0px", paddingBottom: "1em", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Association</Label>
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.name}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Membership No.</Label>
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.membershipNo}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <Row style={{margin: "0px", width: "100%"}}>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Association</Label>
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.name}
                                                            </Col>
                                                            <Label lg={3} sm={2} style={{fontWeight: 500}}>Membership No.</Label>
                                                            <Col lg={9} sm={10} style={{lineHeight: "36px"}}>
                                                                {elem.membershipNo}
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                )
                            }
                        </Col>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br/>

            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/users" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to User List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 
        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </Fragment>
    
  );
}